"use strict";

var deepEntriesL = require("../.internal/entriesDeepL.js");

var objectDeep = require("../.internal/objectDeep.js");

module.exports = clone;

function clone(obj) {
  return objectDeep(deepEntriesL(obj));
}